import request from '@/utils/request'
import { urltemplate } from '@/utils'
import account from './account'
import accountBind from './accountBind'
import config from './config'
import keyword from './keyword'
import traffic from './traffic'
import article from './article'
import product from './product'
import category from './category'
import story from './story'
import search from './search'
import stats from './stats'
import oem from './oem'

const options = {
  urltemplate,
  server: {
    API_SERVER: process.env.VUE_APP_API_SERVER
  }
}

export default {
  account: account(request, options),
  accountBind: accountBind(request, options),
  config: config(request, options),
  keyword: keyword(request, options),
  traffic: traffic(request, options),
  article: article(request, options),
  product: product(request, options),
  category: category(request, options),
  story: story(request, options),
  search: search(request, options),
  stats: stats(request, options),
  oem: oem(request, options)
}
